import React, { Component } from 'react';
import { Row, Col, message, Divider, Input, Icon, Button, Typography } from 'antd';
import user from '../store/soap/user.js';

const { Title } = Typography;

export default class User extends Component {

  state = { 
    centros: [],
    centros_select: [],
    userName: JSON.parse(localStorage.getItem('user')).name,
    password: '',
    load: false,
    value: undefined,
  };


  async componentDidMount() {

  }

  salveUser = async (e) => {
    try {
      message.loading('Alterando...');
      let updateUser = {
        name: this.state.userName
      };
      if (this.state.password !== '') {
        updateUser = {
          password: this.state.password,
          name: this.state.userName
        };
      }
      await user.updateUserMe(updateUser);
      message.success('Usuário alterado com sucesso.');
      let updateStorage = JSON.parse(localStorage.getItem('user'));
      updateStorage.name = this.state.userName;
      localStorage.setItem('user', JSON.stringify(updateStorage));
    }catch(error) {
      const { response } = error;
      if(response.data.message) {
        return message.warning(response.data.message);
      }
      message.warning('Error, tente novamente.');
    }
  }


  handleChange = value => {
    this.setState({ value });
  };

  onChangeUserName = (e) => {
    this.setState({ userName: e.target.value });
  }

  onChangePassword = (e) => {
    this.setState({ password: e.target.value })
  }

  render() {
    const { userName, password } = this.state;
    return (
      <>
        <Title style={{marginTop: 10}} level={3}>Meus dados</Title>

        {
          (JSON.parse(localStorage.getItem('user')).role === 'admin') &&
          <Row className="row-space">
            <Col span={11}>
              <Button 
                type="primary" 
                icon="unordered-list" 
                size="large" 
                block 
                style={{ marginTop: 10 }} 
                onClick={() => this.props.history.push('/user/list')} 
                className="dma-primary">
                Listar usuários
              </Button>
            </Col>
            <Col span={11} offset={2}>
              <Button 
                type="primary" 
                icon="user-add" 
                size="large" 
                block 
                style={{ marginTop: 10 }} 
                onClick={() => this.props.history.push('/user/new')} 
                className="dma-primary">
                Novo usuário
              </Button>
            </Col>
          </Row>
        }

        <Divider orientation="left">Email: {JSON.parse(localStorage.getItem('user')).email}</Divider>

        <Divider orientation="left">Alterar senha:</Divider>
        <Input.Password
          placeholder="Atualizar Senha"
          size="large"
          prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
          value={password}
          onChange={this.onChangePassword}
        />

        <Divider orientation="left">Nome de usuário: ({userName})</Divider>
        <Input 
          placeholder="Atualizar usuário" 
          size="large"
          prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
          value={userName}
          onChange={this.onChangeUserName}
        />
        
        <Button type="primary" icon="check" size="large" block style={{ marginTop: 20 }} onClick={this.salveUser} className="dma-primary">SALVAR</Button>

      </>
    );
  }
};